import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { crd } from "../../constants/styles";
import { gradCardStyle, gradLift } from "../../constants/gradCard";
import Ic from "../common/Ic";
import Avatar from "../common/Avatar";
import ChatBox from "./ChatBox";
import { formatPropAddr } from "../../utils/propertyAddr";

function ChatListPage() {
  const { t, h, props, tens, go, setSelPropId, openChat, setOpenChat } = useContext(Ctx);
  if (openChat) {
    const op = props.find(x => x.id === openChat); const te = tens.find(x => x.id === op?.tid);
    return <div style={{ paddingTop: 16 }}><button onClick={() => setOpenChat(null)} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
      <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{t.chat} - {te?.name}</h2><ChatBox pid={openChat} sender="ll" /></div>;
  }
  return <div style={{ paddingTop: 16 }}><h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{t.chat}</h2>
    {props.filter(p => p.occ).map(p => {
      const te = tens.find(x => x.id === p.tid); return <div key={p.id} onClick={() => setOpenChat(p.id)} onMouseOver={(e) => gradLift(e, "indigo", true)} onMouseOut={(e) => gradLift(e, "indigo", false)} style={{ ...crd(h), ...gradCardStyle("indigo"), cursor: "pointer", display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar src={te?.avatar_url} name={te?.name} size={40} bg="rgba(255,255,255,0.25)" ring="2px solid rgba(255,255,255,0.6)" />
        <div><div style={{ color: "#fff", fontWeight: 600, fontSize: 13 }}>{te?.name}</div><div style={{ color: "rgba(255,255,255,0.85)", fontSize: 11 }}>{formatPropAddr(p)}</div></div>
        <div style={{ marginLeft: "auto" }}><Ic n="msg" s={18} c="#fff" /></div></div>;
    })}
  </div>;
}

export default ChatListPage;
